import { Reveal, Eyebrow, YouTubeEmbed } from "./Reveal";
import { scrollToId } from "@/lib/site";

const SYSTEMS = [
  "Speech & Communication",
  "Attention",
  "Sensory Processing",
  "Sleep",
  "Behavior & Emotions",
  "Digestion",
  "Movement",
  "Other relevant functional patterns",
];

export default function BrainSystems() {
  return (
    <section id="brain-systems" data-testid="brain-systems-section" className="bg-[#F4EFE6] border-y border-[#E5D3AD]/40 py-16 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <Reveal className="order-2 lg:order-1">
          <p className="mb-4 text-[11px] font-semibold tracking-[0.24em] uppercase text-[#5C6E62]">
            Video · Understanding the 11 Brain Systems
          </p>
          <YouTubeEmbed
            testid="brain-systems-video"
            embedId="ZjcblZvhxKA"
            title="Understanding the 11 Brain Systems — Sree Prathama Ayurvedam"
          />
        </Reveal>

        <Reveal delay={0.12} className="order-1 lg:order-2">
          <Eyebrow>Chapter 04 · Deeper Understanding</Eyebrow>
          <h2 className="mt-5 font-serif text-3xl sm:text-4xl lg:text-5xl text-[#1B3B2B] tracking-tight leading-tight">
            11 Brain Systems. <em className="italic text-[#B85D43]">A Deeper Look at Your Child.</em>
          </h2>
          <p className="mt-6 text-base text-[#2D3A32] leading-relaxed">
            The $600 Medha Consultation Pathway goes beyond Nadi Pariksha to explore your child through an 11 Brain
            Systems framework.
          </p>
          <p className="mt-4 text-base text-[#5C6E62] leading-relaxed">
            This assessment looks at functional patterns across different areas of your child's development and daily
            experience — helping parents understand their child beyond a single diagnosis.
          </p>
          <div className="mt-6 flex flex-wrap gap-2.5">
            {SYSTEMS.map((s) => (
              <span
                key={s}
                className="bg-[#FAF7F2] text-[#1B3B2B] px-4 py-2 rounded-full text-xs font-semibold tracking-wide border border-[#E5D3AD]"
              >
                {s}
              </span>
            ))}
          </div>
          <p className="mt-6 text-sm text-[#5C6E62] leading-relaxed italic font-serif">
            The goal is to create a more detailed, individualized picture of the child's functional patterns.
          </p>
          <button
            data-testid="explore-medha-cta"
            onClick={() => scrollToId("packages", "explore_medha")}
            className="mt-8 border border-[#1B3B2B]/30 text-[#1B3B2B] font-semibold tracking-wide text-sm px-8 py-4 rounded-full hover:bg-[#1B3B2B] hover:text-[#FAF7F2] transition-all duration-300"
          >
            EXPLORE THE MEDHA PATHWAY
          </button>
        </Reveal>
      </div>
    </section>
  );
}
